// Curated list of the site's main destinations (mirrors the header menu),
// used by admin editors to attach an optional link to an FAQ answer.
export const SITE_PAGE_OPTIONS = [
  { label: "Home", value: "/" },
  { label: "About Us", value: "/about" },
  { label: "Meet the Team", value: "/team" },
  { label: "Services", value: "/services" },
  { label: "Legal Cashiering", value: "/legal-cashiering" },
  { label: "Business Growth Health Check", value: "/business-health-check" },
  { label: "Insights", value: "/insights" },
  { label: "Blog", value: "/blog" },
  { label: "Podcast", value: "/podcast" },
  { label: "Meeting Room Hire", value: "/meeting-room-hire" },
  { label: "FAQs", value: "/faqs" },
  { label: "Testimonials", value: "/testimonials" },
  { label: "Pricing", value: "/pricing" },
  { label: "Contact", value: "/contact" },
];
